import {Component, Input, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {VisitContext} from "../../visit-context";
import {BerthVisit, BoatmenService} from "@portbase/bezoekschip-service-typescriptmodels";
import {ShipMovementService} from "../ship-movement.service";

@Component({
  selector: 'app-helmsmen-to-berth-summary',
  templateUrl: './helmsmen-to-berth-summary.component.html',
  styleUrls: ['./helmsmen-to-berth-summary.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class HelmsmenToBerthSummaryComponent implements OnInit {

  context = VisitContext;

  @Input() currentBerth: BerthVisit;

  constructor(private shipMovementService: ShipMovementService) { }

  ngOnInit() {
  }

  private nextBerth() : BerthVisit {
    if (this.currentBerth) {
      return this.shipMovementService.nextBerth(this.currentBerth);
    } else {
      return this.context.visit.visitDeclaration.portVisit.berthVisits[0];
    }
  }

  get serviceRequired(): boolean {
    return this.service ? this.service.required : false;
  }

  get service(): BoatmenService {
    let nextBerth = this.nextBerth();
    if (nextBerth) {
      return nextBerth.helmsmenAtArrival;
    }
  }

  get nextBerthName(): string {
    let nextBerth = this.nextBerth();
    if (nextBerth && nextBerth.berth) {
      return nextBerth.berth.name;
    }
  }
}
